// src/pages/Purchase/Purchase Entry/components/CreatePurchaseForm.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Grid,
  DatePicker,
  Typography,
  Flex,
  Radio,
  Select,
  Checkbox,
  Button,
  message,
  Drawer,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

import InputField from "../../../../../components/Input/Input";
import SearchListAutoComplete from "../../../../../components/SearchListAutoComplete";

import {
  fetchSuppliers,
  fetchItems,
  fetchTaxAccs,
  fetchDiscountAccs,
  fetchTagGroupFields,
  fetchBatchAvailability,
  fetchTagsOnEdit,
} from "../../../../../store/commonThunks/lookups";
import {
  fetchPendingPurchaseOrders,
  fetchPurchaseAccs,
  fetchAssetAccs,
  fetchPurchaseEntryNumber,
  fetchPurchaseRecord,
  fetchGetAccountByTypeApi,
} from "../purchaseThunk";
import {
  accessChecker,
  dateTimeFormat,
  formatToCompanyTimezone,
  getYearFromCompanyDate,
  pathSpliter,
} from "../../../../../lib/functions";
import {
  resetPurchaseEntry,
  setSupplier,
  setEntryDate,
  setInvoiceNo,
  setInvoiceDate,
  setTaxMode,
  addOrderRow,
  setTaxAcc,
  setDiscountAcc,
  setPurchaseAcc,
  setAssetAcc,
  setTagFeildNameid,
  setConversionRate,
  setTransportAcc,
  setConversion,
  calculateTotals,
  setVoucherNumber,
  setFormField,
  setFooterValues,
  setPayPurchaseCart,
  updateBatchExpiry,
  updateOrderRow,
  setInvoiceFile,
  setExistingInvoiceUrl,
  setIsTatmeen,
} from "../purchaseSlice";
import { getCurrencyCodeWithName, getCurrencySymbol } from "../../../../../lib/currency";
import { convertCurrency } from "../../../../../utils";
import { selectAuthInfo } from "../../../../Auth/authSelectors";
import SupplierDrawer from "../../Supplier Entry/components/SupplierDrawer";
import AddNewModal from "../../../../../components/DropDown/AddNewModal";
import TagCreateForm from "../../../../Settings/Tags/components/TagCreateForm";
import { fetchProductsList } from "../../../../Products/productsThunks";
import { purchaseOrderRecordnWithDetailsApi, purchaseRecordnWithDetailsApi } from "../../../../../apiservice/purchase";
import { getTagOnEdit } from "../../../../../services/accounts";
import useMigrationDate from "../../../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreatePurchaseForm = ({ convertId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const location = useLocation();
  const [form] = useForm();


  const lookups = useSelector((s) => s.lookups);
  const {
    supplierInfo,
    voucherNumber,
    entryDate,
    invoiceDate,
    taxMode,
    itemCart,
    // authInfo,
    conversionRate,
    tag_field_id,
    sscc_code,
    isTatmeen,
  } = useSelector((s) => s.purchaseEntry);

  const isFieldHidden = (fieldKey, pageKey = "purchase_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey,
    );
  };
  let tags =
    lookups.tagFields.map((tag) => ({
      label: tag.display_text,
      value: tag.id,
      tagid: tag.id,
    })) || [];

  const pendingPOs = useSelector((s) => s.purchaseEntry.pendingPOs);
  const isPO = useSelector((s) => s.purchaseEntry.isPO);
  const invoiceFile = useSelector((s) => s.purchaseEntry.invoiceFile);
  const existingInvoiceUrl = useSelector((s) => s.purchaseEntry.existingInvoiceUrl);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [supplierDrawerOpen, setSupplierDrawerOpen] = useState(false);
  const [tagModal, setTagModal] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [invoicePreview, setInvoicePreview] = useState(null);



  useEffect(() => {
    if (invoiceFile instanceof File) {
      const reader = new FileReader();
      reader.onloadend = () => setInvoicePreview(reader.result);
      reader.readAsDataURL(invoiceFile);
    } else {
      setInvoicePreview(existingInvoiceUrl || null);
    }
  }, [invoiceFile, existingInvoiceUrl]);

  const handleInvoiceFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(setInvoiceFile(file));
    }
  };

  const authInfo = useSelector(selectAuthInfo);
  const currency = authInfo?.currency || "AED";
  const disAndVat = "individual";
  console.log(authInfo.is_tatmeen_enabled, authInfo.country, "is_tatmeen_enabled");
  const showTatmeenColumn =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");
  console.log(hasTatmeenEntryAccess, "hasTatmeenEntryAccess");

  const pathname = location.pathname; // /purchase/edit/9
  const segments = pathname.split("/").filter(Boolean);

  const module = segments[0];   // purchase
  const mode = segments[1];     // edit | create
  const editId = segments[2];

  const symbol = getCurrencySymbol(authInfo?.currency);
  const { selectedPurchaseAcc, purchaseAccList, selectedAssetAcc, assetAccList } = useSelector((s) => s.purchaseEntry);
  // Any asset-flagged item currently in the cart -- shows/requires the Asset Account picker.
  const hasAssetItems = itemCart?.some((item) => item.is_asset);
  useEffect(() => {
    if (mode === "edit") return;
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchPurchaseEntryNumber(year));
  }, [entryDate, mode]);

  useEffect(() => {
    dispatch(fetchSuppliers(""));
    dispatch(fetchPurchaseAccs()).then((res) => {
      if (res?.payload?.length) {
        dispatch(setFormField({ field: "purchaseAccList", value: res.payload }));
        // ✅ Auto-select first account as default
        dispatch(setPurchaseAcc(res.payload[0]));
      }
    });
    dispatch(fetchAssetAccs()).then((res) => {
      if (res?.payload?.length) {
        dispatch(setFormField({ field: "assetAccList", value: res.payload }));
        dispatch(setAssetAcc(res.payload[0]));
      }
    });
    dispatch(fetchTagGroupFields(""));
    dispatch(fetchItems(""));
    dispatch(fetchTaxAccs()).then((res) => {
      if (res.payload?.length > 0) dispatch(setTaxAcc(res.payload[0]));
    });
    dispatch(fetchDiscountAccs()).then((res) => {
      if (res.payload?.length > 0) dispatch(setDiscountAcc(res.payload[0]));
    });
    dispatch(setTaxMode(disAndVat));
    dispatch(fetchGetAccountByTypeApi()).then((res) => {
      if (res?.payload) {
        dispatch(setTransportAcc(res.payload));
      }
    });

  }, [dispatch]);

  useEffect(() => {
    const id = pathSpliter(location.pathname, 3);
    const path =
      pathSpliter(location.pathname, 0) !== undefined
        ? parseFloat(pathSpliter(location.pathname, 0))
        : 0;

    const segments = location.pathname.split("/").filter(Boolean);

    const action = segments[1]; // "edit"
    const editid = segments[2] || 0;
    const pur_o_id = id;
    if (action !== "edit" || id === 0) {
      if (id) {
        dispatch(fetchPurchaseRecord({ pur_o_id: id }));
      }
    }
  }, [location, dispatch]);




  useEffect(() => {
    if (mode !== "edit" || !editId) return;

    (async () => {
      try {
        const res = await purchaseRecordnWithDetailsApi({
          pur_id: editId,
          from: "voucher",
        });

        if (!res?.data?.length) return;

        const v = res.data[0];

        /* =========================
           1. Supplier
        ========================== */
        if (v.acc_id) {
          const supplierObj = {
            acc_id: v.acc_id,
            acc_name: v.acc_name,
            contact_no: v.contact_no,
            institution_name: v.institution_name,
            address: v.address,
            acc_code: v.acc_code,
            display_text: `${v.acc_name} - ${v.acc_code}`,
          };

          dispatch(setSupplier(supplierObj));
          form.setFieldValue("search_supplier", supplierObj);
        }
        if (v.pur_voucher_no) {
          dispatch(setVoucherNumber(v.pur_voucher_no));
        }

        if (v.invoice_image) {
          dispatch(setExistingInvoiceUrl(v.invoice_image));
        }

        dispatch(setFormField({ field: "purchase_id", value: v.pur_id }));
        if (v.sscc_code) {
          dispatch(setFormField({ field: "sscc_code", value: v.sscc_code }));
        }
        if (v.is_tatmeen_product !== undefined) {
          dispatch(setIsTatmeen(v.is_tatmeen_product === 1 || v.is_tatmeen_product === "1"));
        }

        /* =========================
           2. Dates
        ========================== */
        if (v.entry_date) {
          dispatch(setEntryDate(dayjs(v.entry_date).toISOString()));
          form.setFieldValue("entry_date", dayjs(v.entry_date));
        }

        if (v.invoice_date) {
          dispatch(setInvoiceDate(dayjs(v.invoice_date).toISOString()));
          form.setFieldValue("invoice_date", dayjs(v.invoice_date));
        }

        /* =========================
           3. Accounts
        ========================== */
        if (v.purchase_acc_id) {
          dispatch(
            setPurchaseAcc({
              acc_id: v.purchase_acc_id,
              acc_name: v.purchase_acc_name,
            }),
          );
        }

        if (v.asset_acc_id) {
          dispatch(
            setAssetAcc({
              acc_id: v.asset_acc_id,
              acc_name: v.asset_acc_name,
            }),
          );
        }

        if (v.tax_acc_id) {
          dispatch(
            setTaxAcc({
              acc_id: v.tax_acc_id,
              acc_name: v.tax_acc_name,
            }),
          );
        }

        if (v.discount_acc_id) {
          dispatch(setDiscountAcc({
            acc_id: v.discount_acc_id,
            acc_name: v.discount_acc_name,
          }));
        }

        if (v.transport_acc_id) {
          const transportAcc = {
            acc_id: v.transport_acc_id,
            acc_name: v.transport_acc_name || "Transport Cost on Purchase ",
          };
          setTransportAcc(transportAcc);
        }

        /* =========================
           4. Tags
        ========================== */
        if (mode === "edit" && editId) {
          dispatch(fetchTagsOnEdit({
            tab_id: editId,
            type: "purchase_entry"
          }))
            .unwrap()
            .then((tags) => {
              const tagIds = tags.map(t => t.id);
              dispatch(setTagFeildNameid(tagIds));
            });
        }


        /* =========================
           5. Items
        ========================== */
        const items = v.details.map((d, idx) => ({
          // key: idx + 1,
          // product: {
          //   item_id: d.item_id,
          //   item_name: d.item_name,
          //   display_text: d.item_name,
          //   unit_id: d.unit_id,
          // },
          key: `edit-${d.item_id}-${idx}`,
          item_id: d.item_id,
          product: d.item_name,
          product_display: d.display_text || d.item_name,
          is_asset: d.is_asset === "yes",
          child_sscc_code: d.child_sscc_code || "",
          is_serial: d.is_serial || "no",
          serial_mode: d.serial_mode || "unit",
          // ✅ Fix: Derive serial_per_batch from serial_mode
          serial_per_batch: d.serial_mode === "batch",
          quantity: Number(d.item_qty),
          rate: Number(d.item_rate),
          discount: Number(d.item_discount_per),
          discountAmt: Number(d.item_discount) || 0,
          discountMode: d.discount_mode || "percent",
          tax_per: Number(d.item_tax_per),
          total: Number(d.item_total),
          is_tatmeen_required: d.is_tatmeen_required === 1 || d.is_tatmeen_required === "1" || d.is_tatmeen_required === true,

          // batch / packing (same idea )
          batch_id: d.batch_id,
          batch_name: d.batch_name,
          batch_expiry: d.batch_expiry,
          is_expiry_disable: !!d.batch_id,

          packing_name: d.pack_type,
          packing_quantity: d.pack_qty,
          packing_name_quantity: d.pack_defined_qty,
          gtn_num: d.gtn_num || "",
          serials: Array.isArray(d.availableSerials)
            ? d.availableSerials
            : d.serials
              ? String(d.serials)
                .split(",")
                .map(s => s.trim())
                .filter(Boolean)
              : [],
          serial_per_batch: d.serial_per_batch === 1,
        }));

        dispatch(setFormField({ field: "itemCart", value: items }));

        items.forEach((item) => {
          if (item.item_id && item.batch_id) {
            dispatch(fetchBatchAvailability({ item_id: item.item_id }))
              .unwrap()
              .then((res) => {
                const batchList = res?.batches || [];
                const matchedBatch = batchList.find(
                  (b) => b.id === item.batch_id
                );

                if (matchedBatch) {
                  dispatch(updateOrderRow({
                    rowKey: item.key,
                    updates: {
                      batch_expiry: matchedBatch.batch_expiry,
                      is_expiry_disable: true,
                    }
                  }));

                }
              });
          }
        });


        /* =========================
           6. Tax mode & totals
        ========================== */
        dispatch(setTaxMode(v.is_cal_type));
        // dispatch(calculateTotals({authInfo}));


        /* =========================
           7. Transaction Cart
        ========================== */

        const payCart = (v.trans || []).map((t, idx) => {

          let acc_type_id = "cash_in_hand";
          if (t.from_acc_name && t.from_acc_name.toLowerCase().includes("Cash")) {
            acc_type_id = "cash_in_hand"; // or "pdc" if you have a specific type
          } else if (t.to_acc_name && t.to_acc_name.toLowerCase().includes("pdc")) {
            acc_type_id = "cheque"; // or "pdc" if you have a specific type
          } else if (t.to_acc_name && t.to_acc_name.toLowerCase().includes("cdc")) {
            acc_type_id = "cheque"; // or "pdc" if you have a specific type
          } else {
            acc_type_id = "bank_account";
          }



          return {
            key: t.to_acc_name ? t.to_acc_name : t.from_acc_name,
            type: t.to_acc_name ? t.to_acc_name : t.from_acc_name,
            from_acc_name: t.to_acc_name ? t.to_acc_name : t.from_acc_name,
            tran_amount: parseFloat(t.tran_amount) || 0,
            date: t.date || t.tran_date || v.created_date, // Note: t.date comes from API
            from_acc_id: t.to_acc_id ? t.to_acc_id : t.from_acc_id,
            acc_type_id: acc_type_id,
            cheque_number: t.cheque_number,
          };
        });

        /* =========================
           8. Add Expense Cart
        ========================== */

        const payServiceCart = (v.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          from_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          date: t.tran_date || v.created_date,
          from_acc_id: t.to_acc_id,
          acc_type_id: t.acc_type_id || "direct_income",
        }));



        /* =========================
           9. Determine Payment Mode
        ========================== */

        const paymentMode = [];
        if (payCart.length > 0) {
          paymentMode.push("isCheque");
        }

        if (payServiceCart.length > 0 || v.other_service_cost > 0) {
          paymentMode.push("addExpenses");
        }


        /* =========================
           10. Set footer values
        ========================== */

        dispatch(setPayPurchaseCart(payCart));

        const calculatedPaidAmount = payCart
          .filter(item => item.acc_type_id !== "cheque")
          .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);

        dispatch(setFooterValues({
          subtotal: v.sub_total,
          total_discount: v.total_discount,
          totalTax: v.total_tax,
          grandTotal: v.total_amount,
          paidAmount: v.paid_amount,
          discountPct: v.total_discount_per || 0,
          discountAmt: Number(v.total_discount) || 0,
          discountMode: v.total_discount_mode || "percent",
          taxPct: v.total_tax_per || 0,
          other_service_cost: v.other_service_cost || 0,
          description: v.narration || "",

          payCart: payCart,
          addExpenses: payServiceCart.length > 0,
          payServiceCart: payServiceCart,
          paymentMode: paymentMode,

          conversion_rate: parseFloat(v.conversion_rate) || 0,
          conversion_currency: v.conversion_currency || "",
        }));

        dispatch(calculateTotals({ authInfo }));
      } catch (err) {
        console.error("Purchase Edit Load Failed", err);
        message.error("Failed to load purchase record");
      }
    })();
  }, [mode, editId, dispatch, form]);

  useEffect(() => {
    if (!convertId) return;

    let isMounted = true;

    async function loadPurchaseOrder() {
      try {
        const res = await purchaseOrderRecordnWithDetailsApi({
          pur_o_id: convertId,
        });

        if (!res?.data?.length) return;

        const order = res.data[0];
        console.log("Loaded Purchase Order for conversion:", order);

        if (!order || !isMounted) return;

        // Prevent fully converted orders
        if (order.status === "converted") {
          message.error("This Purchase Order is already fully converted.");
          navigate("/purchase");
          return;
        }

        // ✅ Set supplier
        const supplierObj = {
          acc_code: order?.acc_code,
          acc_id: order?.acc_id,
          acc_name: order?.acc_name,
          acc_type_id: order?.acc_type_id || 0,
          acc_type_name: order?.acc_type_name || "",
          address: order?.address,
          contact_no: order?.contact_no,
          country_code: order?.country_code || "1",
          credit_day: order?.credit_day || null,
          credit_limit: order?.credit_limit || 0,
          credit_month: order?.credit_month || "",
          display_text: `${order?.acc_name} - ${order?.acc_code}`,
          institution_name: order?.institution_name,
          party_type: order?.party_type || "",
        };

        dispatch(setSupplier(supplierObj));
        form.setFieldValue("search_supplier", supplierObj);

        // ✅ Map items
        const mappedItems = await Promise.all(
          order.details.map(async (item, index) => {
            const orderedQty = Number(item.item_qty);
            const convertedQty = Number(item.done_item_qty || 0);
            const remainingQty = orderedQty - convertedQty;

            if (remainingQty <= 0) return null;

            return {
              key: `convert-${item.item_id}-${index}`,
              item_id: item.item_id,
              product: item.item_name,
              product_display: item.display_text || item.item_name,
              is_asset: item.is_asset === "yes",
              quantity: remainingQty,
              ordered_qty: orderedQty,
              rate: parseFloat(item.item_rate) || 0,
              discount_per: parseFloat(item.item_discount_per) || 0,
              discount: parseFloat(item.item_discount) || 0,
              discountAmt: parseFloat(item.item_discount) || 0,
              discountMode: item.discount_mode || "percent",
              tax_per: parseFloat(item.item_tax_per) || 0,
              vat: parseFloat(item.item_tax) || 0,
              total: parseFloat(item.item_total) || 0,
              batch_name: item.batch_name || "",
              batch_expiry: item.batch_expiry || null,
              batch_id: item.batch_id || 0,
              is_expiry_disable: false,
              batch_list: [],
              unit_id: item.unit_id,
              unit_symbol: item.unit_symbol,
              packing_name: item.pack_type || null,
              packing_quantity: item.pack_qty || null,
              packing_name_quantity: item.pack_defined_qty || null,
              gtn_num: item.gtn_num || "",
            };
          })
        );

        const finalItems = mappedItems.filter(Boolean);

        if (finalItems.length === 0) {
          message.warning("No remaining quantity to convert.");
          navigate("/purchase");
          return;
        }

        dispatch(setFormField({ field: "itemCart", value: finalItems }));

        // ✅ Load full product details
        order.details.forEach(async (item, index) => {
          if (!finalItems[index]) return;

          try {
            const productFull = await dispatch(
              fetchProductsList({
                query: item.item_name,
                search: false,
                partyType: "general",
              })
            ).unwrap();

            const full = productFull.find((p) => p.item_id === item.item_id);

            if (full) {
              dispatch(
                setFormField({
                  field: "itemCart",
                  value: finalItems.map((fi, idx) =>
                    idx === index ? { ...fi, product: full } : fi
                  ),
                })
              );
            }
          } catch (err) {
            console.error("Failed to load product info:", err);
          }

          if (item.item_id) {
            try {
              const batchRes = await dispatch(
                fetchBatchAvailability({ item_id: item.item_id })
              ).unwrap();

              const batchList = batchRes?.batches || [];

              dispatch(
                setFormField({
                  field: "itemCart",
                  value: finalItems.map((fi, idx) =>
                    idx === index ? { ...fi, batch_list: batchList } : fi
                  ),
                })
              );
            } catch (err) {
              console.error("Failed to load batches:", err);
            }
          }
        });

        // ✅ NEW: Load Service Expenses (Additional Expenses)
        const payServiceCart = (order.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          to_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          to_acc_id: t.to_acc_id,
          from_acc_id: order.acc_id, // supplier account
        }));

        // ✅ Set footer values with expenses
        const other_service_cost = payServiceCart.reduce(
          (sum, item) => sum + parseFloat(item.tran_amount || 0),
          0
        );

        dispatch(setFooterValues({
          description: order.narration || "",
          discountPct: parseFloat(order.total_discount_per) || 0,
          discountAmt: parseFloat(order.total_discount) || 0,
          discountMode: order.total_discount_mode || "percent",
          taxPct: parseFloat(order.total_tax_per) || 0,
          subtotal: parseFloat(order.sub_total) || 0,
          other_service_cost: other_service_cost,
          payServiceCart: payServiceCart, // ✅ Set service expenses
          addExpenses: payServiceCart.length > 0, // ✅ Enable "Add Expenses" checkbox
          paymentMode: payServiceCart.length > 0 ? ["addExpenses"] : [], // ✅ Check the checkbox
        }));

        dispatch(setTaxMode(order.is_cal_type || "individual"));
        dispatch(calculateTotals({ authInfo }));

      } catch (error) {
        console.error("Failed to load purchase order:", error);
        message.error("Failed to load purchase order data");
      }
    }

    loadPurchaseOrder();

    return () => {
      isMounted = false;
    };
  }, [convertId, dispatch, form, navigate, authInfo]);

  const handleSupplierSelect = (supplier) => {
    if (supplier === "add_new") {
      setSupplierDrawerOpen(true);
      return;
    }

    if (supplier) {
      dispatch(setSupplier(supplier));

      const id = pathSpliter(location.pathname, 3);

      if (!id) {
        dispatch(fetchPurchaseRecord({ pur_id: id }));
      }

      if (
        authInfo?.gst_enabled === "yes" &&
        supplier?.gst_type === "unregistered"
      ) {
        dispatch(
          setFormField({
            field: "itemCart",
            value: itemCart.map((item) => ({
              ...item,
              tax_per: 0,
            })),
          })
        );
      }

      // ✅ fetch pending POs for supplier
      dispatch(fetchPendingPurchaseOrders(supplier.acc_id));

      // if no rows → add first empty row
      if (itemCart.length == 0) {
        dispatch(
          addOrderRow({
            key: Date.now(),
            item_id: null,
            product: "",
            quantity: 1,
            rate: 0,
            tax_per: 0,
            discount: 0,
            bonus: false,
            batch_name: "",
            batch_expiry: null,
            batch_id: 0,
            is_expiry_disable: false,
            batch_list: [],
          }),
        );
      }
    } else {
      dispatch(resetPurchaseEntry());
    }
  };

  const handletaggroup = (e, selectedOption) => {
    const value = selectedOption?.map((tag) => tag.tagid);

    dispatch(setTagFeildNameid(value));
  };
  const { disabledDate } = useMigrationDate();
  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={3} >
          Purchase Entry
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>
      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Supplier Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Search Supplier"
              required
              rules={[{ required: true, message: "Select customer" }]}
            >
              <SearchListAutoComplete
                entityType="supplier"
                placeholder="Supplier"
                optionsList={lookups.suppliers.map((c) => ({
                  sale_id: c.acc_id,
                  display_text: [c.acc_name, c.contact_no, c.institution_name]
                    .filter(Boolean)
                    .join(" - "),
                  raw: c,
                }))}
                value={
                  supplierInfo?.acc_id
                    ? {
                      value: supplierInfo.acc_name,
                      label: supplierInfo.acc_name,
                      display_text: supplierInfo.acc_name,
                      raw: supplierInfo,
                    }
                    : null
                }
                onSelect={(obj) =>
                  handleSupplierSelect(obj?.raw ? obj?.raw : obj)
                }
                showAddNew={true}
                disabled={isPO}
              />
            </Form.Item>
            <Form.Item label="Invoice No">
              <InputField
                data-testid="invoice-no"
                onChange={(e) => {
                  const value = e.target.value;
                  dispatch(setInvoiceNo(value));
                }}
              />
            </Form.Item>
            {!isFieldHidden("Upload Invoice") && (
              <Form.Item label="Upload Invoice" className="upload-block-wrap">
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleInvoiceFileChange}
                    style={{ marginBottom: "10px" }}
                  />
                  {invoicePreview && (
                    <div style={{ marginTop: 8 }}>
                      <img
                        src={invoicePreview}
                        alt="Invoice"
                        style={{ maxWidth: "300px", border: "1px solid #ccc" }}
                      />
                      {!(invoiceFile instanceof File) && existingInvoiceUrl && (
                        <Typography.Text type="secondary">
                          Existing invoice
                        </Typography.Text>
                      )}
                    </div>
                  )}
                </div>
              </Form.Item>
            )}

            <Form.Item label="Institution Name">
              <InputField value={supplierInfo?.institution_name} disabled />
            </Form.Item>
            <Form.Item label="Supplier Address">
              <InputField value={supplierInfo?.address} disabled />
            </Form.Item>
            <Form.Item label="Contact No">
              <InputField value={supplierInfo?.contact_no} disabled />
            </Form.Item>
            {showTatmeenColumn && hasTatmeenEntryAccess && <>
              <Form.Item label="SSCC Code">
                <InputField
                  placeholder="Enter SSCC"
                  value={sscc_code}
                  onChange={(e) =>
                    dispatch(
                      setFormField({
                        field: "sscc_code",
                        value: e.target.value,
                      })
                    )
                  }
                />
              </Form.Item>


            </>}


            <Form.Item label="Discount">
              <Radio.Group
                options={[
                  { label: "On Total", value: "on_total" },
                  { label: "On Individual Item", value: "individual" },
                ]}
                onChange={(e) => {
                  dispatch(setTaxMode(e.target.value));
                  dispatch(calculateTotals({ authInfo }));
                }}
                value={taxMode}
              />
            </Form.Item>

          </Flex>

          {/* Order Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Voucher No">
              <InputField
                value={voucherNumber || ""}
                disabled
                data-testid="voucher-no"
              />
            </Form.Item>
            <Form.Item label="Purchase Account">
              <Select
                showSearch
                placeholder="Select Purchase Account"
                optionFilterProp="label"
                value={selectedPurchaseAcc?.acc_id}
                options={(purchaseAccList || []).map((a) => ({
                  label: a.acc_name,
                  value: a.acc_id,
                }))}
                onChange={(val) => {
                  const acc = purchaseAccList.find((a) => a.acc_id === val);
                  dispatch(setPurchaseAcc(acc));
                }}
              />
            </Form.Item>

            {hasAssetItems && (
              <Form.Item label="Asset Account" required>
                <Select
                  showSearch
                  placeholder="Select Asset Account"
                  optionFilterProp="label"
                  value={selectedAssetAcc?.acc_id}
                  options={(assetAccList || []).map((a) => ({
                    label: a.acc_name,
                    value: a.acc_id,
                  }))}
                  onChange={(val) => {
                    const acc = assetAccList.find((a) => a.acc_id === val);
                    dispatch(setAssetAcc(acc));
                  }}
                />
              </Form.Item>
            )}

            <Form.Item label="Entry Date" required>
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) =>
                  dispatch(setEntryDate(d ? d.toISOString() : null))
                }
                format={dateTimeFormat}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item label="Invoice Date" required>
              <DatePicker
                style={{ width: "100%" }}
                value={invoiceDate ? dayjs(invoiceDate) : null}
                onChange={(d) =>
                  dispatch(setInvoiceDate(d ? d.toISOString() : null))
                }
                format={dateTimeFormat}
                disabledDate={disabledDate}
              />
            </Form.Item>

            {/* ✅ NEW: Select Purchase Order */}

            <Form.Item label="Select PO">
              <SearchListAutoComplete
                placeholder="PO"
                style={{ width: "100%" }}
                optionsList={(pendingPOs || []).map((po) => ({
                  sale_id: po.pur_o_id,
                  display_text: `PO-${po.pur_order_no} (${symbol} ${po.total_amount})`,
                  raw: po,
                }))}
                onSelect={(obj) => {
                  const po = obj?.raw;
                  if (!po) return;
                  // fetch order details and fill table
                  dispatch(fetchPurchaseRecord({ pur_o_id: po.pur_o_id }))
                    .unwrap()
                    .then((res) => {
                      res.itemCart.forEach(item => {
                        dispatch(fetchBatchAvailability({ item_id: item.item_id }));
                        dispatch(fetchProductsList({
                          query: item.product,
                          search: true,
                          // partyType("general")
                        }));
                      });
                    });
                }}
                showAddNew={false}
                disabled={!supplierInfo?.acc_id}
              />
            </Form.Item>

            <Form.Item label="Search Tags">
              <Select
                data-testid="roles-select"
                className="tag-multiselect"
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: "100%" }}
                onChange={(e, options) => handletaggroup(e, options)}
                value={tag_field_id || null}
                placeholder="Select Tags"
                options={tags}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 8,
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <Button type="link" onClick={() => setTagModal(true)}>
                        + Add New Tag
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>
            {!isFieldHidden("Convert Currency") && (
              <Form.Item>
                <Checkbox
                  onChange={(e) => {
                    const checked = e.target.checked;

                    SetIsConvertCurrencyShow(checked);

                    if (!checked) {
                      // 🔥 Reset conversion
                      dispatch(setConversionRate(0));
                      dispatch(setConversion(null, "conversion_currency"));
                    }
                  }}
                >
                  Convert Currency
                </Checkbox>
              </Form.Item>
            )}
            {showTatmeenColumn && hasTatmeenEntryAccess && <>
              <Form.Item label="Tatmeen">
                <Checkbox
                  checked={isTatmeen}
                  disabled={mode == "edit"}
                  onChange={(e) => {
                    dispatch(setIsTatmeen(e.target.checked));
                  }}
                >
                  Enable Tatmeen
                </Checkbox>
              </Form.Item>
            </>}
          </Flex>
        </Flex>
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {isConvertCurrencyShow && (
            <>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Choose Currency">
                  <Select
                    showSearch
                    placeholder="Select Currency"
                    style={{ minWidth: 200 }}
                    options={getCurrencyCodeWithName().map((c) => ({
                      value: c.code,
                      label: `${c.currency} (${c.code})`,
                    }))}
                    onChange={async (toCurrency) => {
                      const rate = await convertCurrency(currency, toCurrency);

                      if (rate) {
                        // store conversion rate once for use in InvoiceTable
                        // handleFooterChange(rate, "conversion_rate");
                        dispatch(
                          setConversion(toCurrency, "conversion_currency"),
                        );
                        dispatch(setConversionRate(rate));
                        // setConversionRate(rate);
                      }
                    }}
                  />
                </Form.Item>
              </Flex>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Conversion Rate">
                  <InputField value={conversionRate} disabled />
                </Form.Item>
              </Flex>
            </>
          )}
        </Flex>
      </Form>

      <SupplierDrawer
        open={supplierDrawerOpen}
        onClose={() => setSupplierDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(supplier) => {
          if (!supplier) return;

          //  Update Redux
          dispatch(setSupplier(supplier));

          dispatch(fetchSuppliers());

          //  Update form field
          form.setFieldValue("search_supplier", {
            value: supplier.acc_name,
            label: supplier.acc_name,
            display_text: supplier.acc_name,
            raw: supplier,
          });

          // if no rows → add first empty row
          if (itemCart.length === 0) {
            dispatch(
              addOrderRow({
                key: Date.now(),
                item_id: null,
                product: "",
                quantity: 1,
                rate: 0,
                tax_per: 0,
                discount: 0,
                bonus: false,
                batch_name: "",
                batch_expiry: null,
                batch_id: 0,
                is_expiry_disable: false,
                batch_list: [],
              }),
            );
          }
          //  Load dependent data (same as normal select)
          dispatch(fetchItems(supplier?.party_type || false));
          dispatch(fetchTaxAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setTaxAcc(res.payload[0]));
            }
          });

          dispatch(fetchDiscountAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setDiscountAcc(res.payload[0]));
            }
          });
        }}
      />

      <AddNewModal
        open={tagModal}
        title="Add Tag"
        onClose={() => setTagModal(false)}
      >
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ groupId, createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();

            const match = res.find(
              (t) =>
                t?.raw?.field_name?.toLowerCase() === createdName.toLowerCase(),
            );

            if (!match) {
              message.warning("Tag creation failed or tag not found");
              setTagModal(false);
              return;
            }

            if (tag_field_id.includes(match.id)) {
              message.info("Tag already exists and is already selected");
              setTagModal(false);
              return;
            }

            // ✅ New tag OR existing but not selected
            dispatch(setTagFeildNameid([...tag_field_id, match.id]));
            message.success("Tag added");

            setTagModal(false);
          }}
        />
      </AddNewModal>
      <Drawer
        title="Purchase Entry Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Purchase Entry
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Purchase Entry module is used to record and manage supplier
            purchase transactions within the ERP system. It helps update
            inventory, supplier accounts, taxes, and financial records
            accurately during procurement operations.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Purchase Entry</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Purchase → Purchase Entry</strong></li>
              <li>Select or create the supplier</li>
              <li>Verify voucher number and invoice details</li>
              <li>Select purchase account</li>
              <li>Add products/items with quantity and pricing</li>
              <li>Apply discounts, or transport charges if required</li>
              <li>Select pending PO if purchase is linked to an order</li>
              <li>Review totals and supplier details</li>
              <li>Click <strong>Save</strong> to complete the purchase entry</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Supplier selection is required before saving.</li>
              <li>Inventory stock updates automatically after saving.</li>
              <li>Purchase totals change based on VAT and discount settings.</li>
              <li>Currency conversion can be enabled if required.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreatePurchaseForm;
